import { render, staticRenderFns } from "./MemberNew.vue?vue&type=template&id=bf3b82cc&"
import script from "./MemberNew.vue?vue&type=script&lang=js&"
export * from "./MemberNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports